module.exports = __webpack_public_path__ + "media/newstyle/images/icon-select-arrow-16e434a154e12e74e24422bd9b4b5644.svg";